import {Injectable} from '@angular/core';
import {HttpEvent, HttpInterceptor, HttpHandler, HttpRequest} from '@angular/common/http';
import {Observable} from 'rxjs';
import {AuthService} from "@services/auth.service";
import {StorageHelperService} from "@services/storage-helper.service";

@Injectable()
export class TokenInterceptor implements HttpInterceptor {

  constructor(private authService: AuthService, private storageHelperService: StorageHelperService) {
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    // We must make sure the user object is retrieved from local storage before we
    // try to amend the request to append the Login-Token header
    const token = this.storageHelperService.get('token');
    if(token && token.token){
      req = req.clone({
        headers: req.headers.set('Login-Token', token.token),
      });
      req = req.clone({
        headers: req.headers.set('From', 'Shop'),
      });
    }

    return next.handle(req);
  }
}
